import { Injectable, inject } from '@angular/core';

import { EventCarouselFixtureResponse } from '@cds/betting-offer/domain-specific/event-carousel';
import { EventCarouselFixtureRequest } from '@cds/query-objects';
import { BaseCdsApi, BaseCdsApiFactory, CDS_API_FACTORY } from '@frontend/sports/content-distribution/feature';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class EventCarouselApi {
    private cdsApi: BaseCdsApi;

    constructor() {
        const cdsApiServiceFactory = inject<BaseCdsApiFactory>(CDS_API_FACTORY);

        this.cdsApi = cdsApiServiceFactory({ endpoint: '/eventcarousel' });
    }

    getFixtureList(request: EventCarouselFixtureRequest): Observable<EventCarouselFixtureResponse | undefined> {
        return this.cdsApi.get<EventCarouselFixtureResponse>(`/fixtures`, request);
    }
}
